import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/icon/success.module.css";

export default {
  "animateSuccessLong": "success-module__animateSuccessLong_Qrkmdq__010",
  "animateSuccessTip": "success-module__animateSuccessTip_Qrkmdq__010",
  "hideCorners": "success-module__hideCorners_Qrkmdq__010",
  "icon": "success-module__icon_Qrkmdq__010",
  "line": "success-module__line_Qrkmdq__010",
  "lineLong": "success-module__lineLong_Qrkmdq__010",
  "lineTip": "success-module__lineTip_Qrkmdq__010",
  "ring": "success-module__ring_Qrkmdq__010",
  "rotatePlaceholder": "success-module__rotatePlaceholder_Qrkmdq__010"
};
      